var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPresentContentIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 21,
    viewBox: "0 0 27 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.84835 20.7375H25.1817C25.9838 20.7375 26.64 20.0812 26.64 19.2791V1.72078C26.64 0.918701 25.9838 0.262451 25.1817 0.262451H1.84835C1.04626 0.262451 0.390015 0.918701 0.390015 1.72078V19.2791C0.390015 20.0812 1.04626 20.7375 1.84835 20.7375ZM7.68168 10.5H10.5983V16.3333H16.4317V10.5H19.3483L14.04 5.17704C13.7483 4.88537 13.2963 4.88537 13.0046 5.17704L7.68168 10.5Z",
    fill: "#FAFAFA"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPresentContentIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/presentContentIcon.f15ba6d223731ea21ec721b0f16ea71f.svg";